<template>
    <div class="flex h-screen bg-default">
        <!-- Desktop sidebar -->
        <Sidebar class="hidden lg:flex" />

        <!-- Mobile sidebar -->
        <USlideover v-model:open="mobileMenuOpen" side="left" :ui="{ content: 'w-72 max-w-[80vw]' }">
            <template #content>
                <Sidebar class="flex w-full" @navigate="mobileMenuOpen = false" />
            </template>
        </USlideover>

        <div class="flex min-w-0 flex-1 flex-col">
            <Topbar @toggle-menu="mobileMenuOpen = !mobileMenuOpen" />
            <main class="mb-4 flex-1 overflow-auto p-3 sm:p-4 lg:mb-8">
                <RouterView />
            </main>
            <Footer />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { RouterView } from 'vue-router'

    import Footer from '@/layouts/components/Footer.vue'
    import Sidebar from '@/layouts/components/Sidebar.vue'
    import Topbar from '@/layouts/components/Topbar.vue'
    import { useAppStore } from '@/stores/app'

    const appStore = useAppStore()

    const mobileMenuOpen = computed({
        get: () => appStore.mobileMenuOpen,
        set: (value: boolean) => { appStore.mobileMenuOpen = value }
    })
</script>
